import React from 'react';
import { Select } from 'antd';
import _ from 'lodash';

import queryTypes from '../../constants/usage';
import { prepareDropdown } from '../../utils/common';
import FieldsSelect from '../common/FieldsSelect';
import { fieldTypes, groupByExcludeFields, splitByExcludeFields } from '../../constants/metainf';
import UsageExecutionOptionsBar from '../../containers/usage/UsageExecutionOptionsBar';
import { types } from '../../constants/filter';

const { Option } = Select;

const getFields = (metainf, extraGroups) =>
  _.isNil(metainf) ? [] : prepareDropdown(metainf, true, extraGroups);

const excludeFields = [
  fieldTypes.STRING,
  fieldTypes.DATE,
  fieldTypes.COHORT,
  fieldTypes.SEGMENT,
  fieldTypes.NUMBER,
  types.BOOL,
];

const getFieldsGroupBy = (metainf, queryType) => {
  if (!_.isNil(metainf)) {
    if (queryType === queryTypes.USERS) {
      return getFields(metainf, excludeFields);
    }
    return getFields(metainf, groupByExcludeFields);
  }
  return [];
};

const UsageMainOptionsBar = ({
  queryType,
  groupColumn,
  metainf,
  splitColumn,
  onChangeQueryType,
  onChangeGroupColumn,
  onChangeSplitColumn,
}) => {
  const metainfFields = getFieldsGroupBy(metainf, queryType);

  // ! скрытие Quarter в выпадающем списке
  const transformMetainfFields = metainfFields.map((fieldItem) => {
    let filteredField = fieldItem;

    if (fieldItem.title === 'Time') {
      const fieldWithoutQuater = fieldItem.fields.filter((item) => {
        return item.name !== 'Quarter';
      });
      filteredField = { ...filteredField, fields: fieldWithoutQuater };
    }
    return filteredField;
  });

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <div>
        <Select
          onSelect={(qt) => onChangeQueryType(qt)}
          value={queryType}
          style={{ width: 'auto', minWidth: 120 }}
          dropdownMatchSelectWidth
          dropdownStyle={{ width: 'auto' }}
          className="ant-select-border-bottom"
          getPopupContainer={(triggerNode) => triggerNode}
          virtual={false}
        >
          <Option value={queryTypes.USERS}>Users</Option>
          <Option value={queryTypes.SESSIONS}>Sessions</Option>
        </Select>

        <span style={{ margin: '0px 5px' }}>by</span>

        <FieldsSelect
          onSelect={(groupColumnParam) => onChangeGroupColumn(groupColumnParam)}
          value={groupColumn}
          fields={transformMetainfFields}
          style={{ width: 'auto', minWidth: 120, marginRight: 5 }}
          allowClear={false}
        />
        <span style={{ marginRight: 5 }}>split by</span>
        <FieldsSelect
          onSelect={(splitColumnParam) => onChangeSplitColumn(splitColumnParam)}
          value={splitColumn}
          fields={getFields(metainf, splitByExcludeFields)}
          style={{ width: 'auto', minWidth: 140 }}
          allowClear
        />
      </div>
      <UsageExecutionOptionsBar />
    </div>
  );
};

export default UsageMainOptionsBar;
